// extracted by mini-css-extract-plugin
module.exports = {"map":"locationList_map__3nLr_"};